import { Injectable } from '@angular/core';
import { GrantedPermitionsService } from './granted-permitions.service';

@Injectable({
  providedIn: 'root'
})
export class GeolocalizationService {

  constructor(private permitionService: GrantedPermitionsService) { }

  requestGeolocationPermission(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      if (!('geolocation' in navigator)) {
        return reject(new Error('La geolocalización no es compatible.'));
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.saveGeolocationToLocalStorage(position);
          resolve(position);
        },
        (error) => {
          console.error("Error detallado:", error.code, error.message);
          reject(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 15000,           
          maximumAge: 0,        
        }
      );
    });
  }

  private saveGeolocationToLocalStorage(position: GeolocationPosition): void {
    const geolocationData = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      accuracy: position.coords.accuracy,
      timestamp: position.timestamp,
    };
    sessionStorage.setItem('userGeolocation', JSON.stringify(geolocationData));
  }

  getStoredGeolocation(): any | null {
    const storedData = sessionStorage.getItem('userGeolocation');
    return storedData ? JSON.parse(storedData) : null;
  }

  clearStoredGeolocation(): void {
    sessionStorage.removeItem('userGeolocation');
  }

  // En GeoService
  verificarPermisoIOS() {
    // Si no existe la API de permissions (común en Safari)
    if (!navigator.permissions || !navigator.permissions.query) {
      navigator.geolocation.getCurrentPosition(
        () => this.actualizarEstado('granted'),
        (err) => {
          if (err.code === 1) this.actualizarEstado('denied');
        },
        { timeout: 2000 } // Intento rápido
      );
    }
  }

  actualizarEstado(nuevoEstado: string): void {
    this.permitionService.actualizarEstado(nuevoEstado);
  }
}

